import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function addGroupMembers(group, members) {
	return fetch(
		`${ENDPOINT_URL}/addmembers`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				group,
				members,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
